/**
 * Data hook for listing a distributor's sub-catalogs (custom catalogs).
 * Used to populate the chat Settings sub-catalog select.
 */

import { useListAllSubCatalogs } from '../../../hooks';
import type { SubCatalog } from '../../../hooks';

export type ChatSubCatalog = SubCatalog;

export interface UseListSubCatalogsResponse {
  subCatalogs: ChatSubCatalog[];
  isLoading: boolean;
  error: Error | null;
}

export const useListSubCatalogs = (
  supplierId?: string
): UseListSubCatalogsResponse => {
  const { subCatalogs, isLoading, error } = useListAllSubCatalogs(supplierId);

  return { subCatalogs, isLoading, error };
};
